// extracted by mini-css-extract-plugin
export default {"button":"styles_button__lj+NB","title":"styles_title__tB0Y7","primary":"styles_primary__EGD3D","slide-in-bottom":"styles_slide-in-bottom__xroQy"};